"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportItems = exports.useSearchItems = exports.useUpdateItems = exports.useCreateItems = exports.useFetchItems = void 0;
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const itemsAction_1 = require("./itemsAction");
const useFetchItems = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchItemsLoading = (0, react_redux_1.useSelector)((state) => state['items/fetch'].loading);
    const fetchItemsError = (0, react_redux_1.useSelector)((state) => state['items/fetch'].error);
    const fetchItemsData = (0, react_redux_1.useSelector)((state) => state['items/fetch'].data);
    const fetchItems = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, itemsAction_1.fetch)(payload));
    });
    return {
        fetchItems,
        fetchItemsLoading,
        fetchItemsError,
        fetchItemsData
    };
};
exports.useFetchItems = useFetchItems;
const useCreateItems = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createItemsLoading = (0, react_redux_1.useSelector)((state) => state['items/create'].loading);
    const createItemsError = (0, react_redux_1.useSelector)((state) => state['items/create'].error);
    const createItemsData = (0, react_redux_1.useSelector)((state) => state['items/create'].data);
    const createItems = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, itemsAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in creating item");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createItems,
        createItemsLoading,
        createItemsError,
        createItemsData
    };
};
exports.useCreateItems = useCreateItems;
const useUpdateItems = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateItemsLoading = (0, react_redux_1.useSelector)((state) => state['items/update'].loading);
    const updateItemsError = (0, react_redux_1.useSelector)((state) => state['items/update'].error);
    const updateItemsData = (0, react_redux_1.useSelector)((state) => state['items/update'].data);
    const updateItems = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, itemsAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in updating item");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateItems,
        updateItemsLoading,
        updateItemsError,
        updateItemsData
    };
};
exports.useUpdateItems = useUpdateItems;
const useSearchItems = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const searchItemsLoading = (0, react_redux_1.useSelector)((state) => state['items/search'].loading);
    const searchItemsError = (0, react_redux_1.useSelector)((state) => state['items/search'].error);
    const searchItemsData = (0, react_redux_1.useSelector)((state) => state['items/search'].data);
    const searchItems = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, itemsAction_1.search)(payload));
    });
    return {
        searchItems,
        searchItemsLoading,
        searchItemsError,
        searchItemsData
    };
};
exports.useSearchItems = useSearchItems;
const useImportItems = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const importItemsLoading = (0, react_redux_1.useSelector)((state) => state['items/import'].loading);
    const importItemsError = (0, react_redux_1.useSelector)((state) => state['items/import'].error);
    const importItemsData = (0, react_redux_1.useSelector)((state) => state['items/import'].data);
    const importItemsCsv = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, itemsAction_1.importItems)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error((res.error && res.error.message) || "Error in importing item");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        importItemsCsv,
        importItemsLoading,
        importItemsError,
        importItemsData
    };
};
exports.useImportItems = useImportItems;
